<!-- 新增或编辑产业园 -->
<template>
  <div id="addOrEditIndustrial">
    <a-form-model :model="industrialVO" ref="addOrUpdateForm" layout="vertical">
      <div class="mansionBaseDiv">
        <a-row  :gutter="16">

          <!-- 产业园名称 -->
          <a-col :span="6" class="baseRow">
            <a-form-model-item prop="industrialInfo.name" :label="$t('industrial.addIndustrial.name')" class="required"
                               :rules=" [ {required: true,message: $t('industrial.addIndustrial.addNamePlaceholder'),},
                {min: 1, max: 128, message: $t('mansion.addMansion.form.errorTip.textMaxLength'), trigger: 'blur'},
              ]">
              <a-input v-model="industrialVO.industrialInfo.name"
                       :placeholder="$t('industrial.addIndustrial.placeholder')"></a-input>
            </a-form-model-item>
          </a-col>

          <!-- 简称 -->
          <a-col :span="6" class="baseRow">
            <a-form-model-item prop="industrialInfo.shortName" :label="$t('industrial.addIndustrial.shortName')">
              <a-input v-model="industrialVO.industrialInfo.shortName"
                       :placeholder="$t('industrial.addIndustrial.placeholder')"></a-input>
            </a-form-model-item>
          </a-col>

          <!-- 类型 -->
          <a-col :span="6" class="baseRow">
            <a-form-model-item prop="industrialInfo.type" :label="$t('industrial.addIndustrial.type')" class="required"
                               :rules=" [ {required: true,message: $t('industrial.addIndustrial.addTypePlaceholder'),},]">
              <pt-select mode="multiple"  v-model="industrialVO.industrialInfo.type" style="width: 100%" @changeValue="changeValue" class="searchSelect" :placeholder="$t('industrial.tableHeader.choice')">
                <a-select-option v-for="(item,index) in industrialDataStep.typeSetList" :key="index" :value="item.wordKey">{{item.wordValue}}</a-select-option>
              </pt-select>
            </a-form-model-item>
          </a-col>

          <!-- 开发模式 -->
          <a-col :span="6" class="baseRow">
            <a-form-model-item prop="industrialInfo.development" :label="$t('industrial.addIndustrial.development')" class="required"
                               :rules=" [ {required: true,message: $t('industrial.addIndustrial.addDevelopmentPlaceholder'),},]">
              <pt-select   v-model="industrialVO.industrialInfo.development" style="width: 100%" @changeValue="changeValue" class="searchSelect" :placeholder="$t('industrial.tableHeader.choice')">
                <a-select-option v-for="(item,index) in industrialDataStep.developmentModeList" :key="index" :value="item.wordKey">{{item.wordValue}}</a-select-option>
              </pt-select>
            </a-form-model-item>
          </a-col>

          <!-- 楼栋数 -->
          <a-col :span="6" class="baseRow">
            <a-form-model-item prop="industrialInfo.number" :label="$t('industrial.addIndustrial.number')" class="required"
                               :rules=" [ {required: true,message: $t('industrial.addIndustrial.addNumberPlaceholder'),},]">
              <a-input-number v-model="industrialVO.industrialInfo.number" style='width: 100%'
                              :placeholder="$t('industrial.addIndustrial.placeholder')"></a-input-number>
            </a-form-model-item>
          </a-col>

          <!-- 宿舍楼栋数 -->
          <a-col :span="6" class="baseRow">
            <a-form-model-item prop="industrialInfo.number" :label="$t('industrial.addIndustrial.dormitoryNumber')" class="required"
                               :rules=" [ {required: true,message: $t('industrial.addIndustrial.addDormitoryNumberPlaceholder'),},]">
              <a-input-number v-model="industrialVO.industrialInfo.dormitoryNumber" style='width: 100%'
                              :placeholder="$t('industrial.addIndustrial.placeholder')"></a-input-number>
            </a-form-model-item>
          </a-col>


          <!-- 所在城市 -->
          <a-col :span="6" class="baseRow">
            <a-form-model-item prop="industrialInfo.city" :label="$t('industrial.addIndustrial.city')" class="required"
                               :rules=" [ {required: true,message: $t('industrial.addIndustrial.addCityPlaceholder'),},]">
              <pt-cascader change-on-select
                           v-model="industrialVO.industrialInfo.city"
                           :cityDatas="cityData" :placeholder="$t('mansion.addMansion.placeholder.regionStr')" @changeValue="changeRegion" ></pt-cascader>
            </a-form-model-item>
          </a-col>


          <!-- 地理坐标 -->
          <a-col :span="6" class="baseRow">
            <a-form-model-item prop="coordinate" :label="$t('industrial.addIndustrial.coordinate')">
              <a-input v-model="coordinate"
                       :placeholder="$t('industrial.addIndustrial.coordinatePlaceholder')"></a-input>
            </a-form-model-item>
          </a-col>

          <!-- 详细地址 -->
          <a-col :span="12" class="addressRow">
            <a-form-model-item prop="industrialInfo.address" :label="$t('industrial.addIndustrial.address')">
              <a-input v-model="industrialVO.industrialInfo.address"
                       :placeholder="$t('industrial.addIndustrial.addressPlaceholder')">
                <span slot="suffix" style="font-size: 12px;color: #999999;cursor: pointer"  @click="openMap"><a-icon  type="environment" style="padding-right:5px;color: rgba(0, 0, 0, 0.25);"></a-icon>{{ $t('keydingwei') }}</span>
              </a-input>
            </a-form-model-item>
          </a-col>


        </a-row>

      </div>
    </a-form-model>

    <pt-modal :footer="true" :title="$t('industrial.mapSearch.title')" :width="1000" :visible="mapModel.visible" @cancel="closeMap">
      <div  slot="content"  class="amap-page-container">
        <pt-map  :center="curCity" :style="mapStyle" @getClickInfo="getClickInfo" :zoom="zoom" :keyword="industrialVO.industrialInfo.name"></pt-map>
<!--        <baidu-map ref="ptMap" v-bind:style="mapStyle" class="bm-view" :center="curCity" :zoom="zoom" :scroll-wheel-zoom="true" @ready="handler"-->
<!--                   @click="getClickInfo" >-->
<!--          <bm-view style="width: 100%; height:500px;"></bm-view>-->
<!--          <bm-marker  :position="defaultPoint" :dragging="true" animation="BMAP_ANIMATION_BOUNCE" v-if="$route.query.industrialId">-->
<!--            <bm-label :content="industrialVO.industrialInfo.address" :labelStyle="{color: 'red', fontSize : '12px'}" :offset="{width: -35, height: 30}"/>-->
<!--          </bm-marker>-->
<!--          <bm-control :offset="{width: '10px', height: '10px'}">-->
<!--            <bm-auto-complete  @confirm="confirm" v-model="keyword" :sugStyle="{zIndex: completeIndex}">-->
<!--              <input ref="mapInput" type="text" :placeholder="$t('mansion.mapSearch.placeholder')" class="serachinput">-->
<!--            </bm-auto-complete>-->
<!--          </bm-control>-->
<!--          <bm-local-search-->
<!--            v-if="keyword != null && keyword !== ''"-->
<!--            :pageCapacity="pageCapacity"-->
<!--            :panel="panel" :location="companyCity" :forceLocal="false" :keyword="keyword" :auto-viewport="true" class="searchResult"></bm-local-search>-->
<!--        </baidu-map>-->
      </div>
    </pt-modal>


  </div>
</template>
<script>


import { findCascadingData } from '@/api/sys/datadict'
import { mapState } from 'vuex'
import { getIndustrialDataStep, saveIndustrial } from '@/api/database/industrial'
import PtCollapse from '@/components/collapse/index.vue'
import PtInput from '@/components/form/input.vue'

export default {
  components: {   PtInput,   PtCollapse },
  data() {
    return {
      cityData:[],
      submitLoading:false,//防止表单重复提交
      coordinate:'',//坐标
      types:[],//产业园类型
      industrialId:null,//产业园id,
      industrialDataStep:{},
      industrialBuildingList:[],
      industrialImgList:[],
      industrialFileList:[],
      industrialVO:{
        industrialInfo:{},//产业园基本信息
        industrialChargeDO:{},//产业园收费信息
        industrialTrafficDO:{},//产业园交通信息
        industrialBuildingLists:[],//产业园楼栋信息
        industrialDormitoryLists:[],//产业园宿舍楼栋信息
        industrialImgLists:[],//产业园图片信息
        industrialFileLists:[],//产业园文件信息
      },
      defaultPoint:{
        lng: 116.404,
        lat: 39.915
      },//默认经纬度
      center: {
        lng: 113.952925,
        lat: 22.541696
      },
      addressLat:null,
      addressLng:null,
      completeIndex:999999,
      companyInfo:{},//公司信息
      companyCity:"深圳市",//城市信息
      mapModel:{
        visible:false,
      },
      curCity:'深圳',
      zoom: 15,
      pageCapacity:5,
      keyword: '',
      panel:false,
      mapStyle: {
        width: '100%',
        height: this.mapHeight + 'px'
      },
    }
  },
  computed:{
    ...mapState({
      userInfo: state => state.user.info
    }),
  },
  mounted() {

    this.initDate();//初始化


  },
  methods: {

    initDate(){
      this.queryCityDataByCity();//查询楼宇设置
      this.getIndustrialDataStep();//获取产业园数据字典相关
      this.initIndustrialBuilding()

    },

    submitIndustrial() {
      this.submitLoading = true;
      this.$refs.addOrUpdateForm.validate().then(res => {

        let industrialBuilding = {
          building: '全部',//楼栋名称
        }
        this.industrialVO.industrialBuildingLists.push(industrialBuilding)

        if(this.industrialVO.industrialInfo.dormitoryNumber > 0){
          let industrialDormitory = {
            dormitory: '全部',//楼栋名称
          }
          this.industrialVO.industrialDormitoryLists.push(industrialDormitory)
        }

        saveIndustrial(this.industrialVO).then(res => {
          if(res.code == 1){
            this.$message.success('保存成功')
            // this.$router.push({ path: '/db/industrial' })
            this.$emit('saveSuccess',res.data.industrialInfo.id,res.data.industrialInfo.name)
          }else{
            console.log("保存失败")
            this.$message.warn('保存失败')
            this.submitLoading = false;
          }
        }).catch(err => {
          console.log("保存失败")
          this.$message.warn('保存失败')
          this.submitLoading = false;
        })

      }).catch(err => {
        console.log("表单验证不通过")
        this.$message.warn('请正确输入表单')
        this.submitLoading = false;
      })







    },

    initIndustrialBuilding(){
      let industrialBuilding = {
        building: '全部',//楼栋名称
        totalFloor: undefined,//总楼层
        floorNum: undefined,//楼层号
        floorArea: undefined,//建筑面积
      }
      this.industrialBuildingList.push(industrialBuilding)
    },

    uploadImgSuccess(file,fileId,number){
      var industrialImg = {
        type:number,
        fileId:fileId,
        fileName:file.name
      }
      this.industrialImgList.push(industrialImg);
    },

    changeValue(){

    },
    getImageUrl(fileId){
      let url = this.$util.getFileUrl(fileId);
      return url;
    },
    changeRegion(){

    },
    //获取产业园数据字典相关
    getIndustrialDataStep(){
      getIndustrialDataStep().then(res=>{
        this.industrialDataStep = res.data
      })

    },
    queryCityDataByCity(){//根据城市查询区域位置
      let this_ = this
      findCascadingData("system.mansion_set.address",4,null).then(res=>{
        this_.cityData = res.data
      })
    },
    openMap(){
      this.companyCity = this.companyInfo.cityName;
      this.mapModel.visible = true;
      this.flag = 0;
      if(this.$route.query.mansionId){
        this.defaultPoint.lat = this.industrialVO.industrialInfo.addresslat;
        this.defaultPoint.lng = this.industrialVO.industrialInfo.addressLng;
        this.keyword = "";
      }else{
        if(this.$refs.addOrUpdateForm.getFieldValue("name") != null && this.$refs.addOrUpdateForm.getFieldValue("name") !== undefined){
          this.keyword = this.$refs.addOrUpdateForm.getFieldValue("name");
        }
      }
      this.$refs.ptMap.map.centerAndZoom(this.companyCity,13)
    },
    handler ({ BMap, map }) {
      setTimeout(()=>{
        if(this.$route.query.mansionId){
          this.defaultPoint.lat = this.industrialVO.industrialInfo.addresslat;
          this.defaultPoint.lng = this.industrialVO.industrialInfo.addressLng;
          this.keyword = "";
        }else{
          if(this.$refs.addOrUpdateForm.getFieldValue("name") != null && this.$refs.addOrUpdateForm.getFieldValue("name") !== undefined){
            this.keyword = this.$refs.addOrUpdateForm.getFieldValue("name");

          }
        }
        this.$refs.mapInput.value = this.keyword;
        this.completeIndex = -99;
        map.centerAndZoom(this.companyCity,13)
      },1)
    },
    closeMap(){
      this.mapModel.visible = false;
    },
    getClickInfo (e) {
      this.center.lng = e.point.lng
      this.center.lat = e.point.lat
      this.queryAddress(e);
    },
    queryAddress(e){ //获取详细地址
      let lng = e.point.lng
      let lat = e.point.lat
      let vueObj = this;
      vueObj.addresslat = lat;
      vueObj.addresslng = lng;
      vueObj.industrialVO.industrialInfo.addressLat = lat
      vueObj.industrialVO.industrialInfo.addressLng = lng
      vueObj.coordinate = 'x:' + lng + ' , ' + 'y:' + lat
      //省市区信息
      console.log(vueObj.flag)
      if (vueObj.flag===0) {
        vueObj.industrialVO.industrialInfo.address = e.address
      }
      if(vueObj.province){
        vueObj.queryCityDataByCity();
      }
      if(vueObj.city){
        vueObj.queryMetrLineByCity();
      }
      vueObj.mapModel.visible = false;
    },
  }
}


</script>
<style scoped lang='less'>

#addOrEditIndustrial{
  background: rgba(248,249,251,0.62);
  border-radius: 4px;
  padding: 20px 20px 0 20px;
  .importIncon{
    display: inline-block;
    margin-left: 4px;
    content: '*';
    font-family: SimSun;
    line-height: 1;
    font-size: 14px;
    color: #FABE00;
  }
  .fromLable{
    font-size: 12px;
    color: #999999;
    letter-spacing: 0;
  }
  .mustFill{
    display: inline-block;
    margin-left: 4px;
    content: '*';
    font-family: SimSun;
    line-height: 1;
    font-size: 14px;
    color: #f5222d;
  }
  .mansionFloorSet{
    padding:0 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background: #F4F5F8;
    height: 40px;
    align-items: center;
    .setLable{
      font-size: 12px;
      color: #333333;
      letter-spacing: 0;
    }
  }
  .addMansionTitle{
    margin: 0 10%;
    font-size: 18px;
    color: #333333;
    letter-spacing: 0;
  }
  .mansionSubmint{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    border:2px solid #F4F5F8;
    position: fixed;
    left: 198px;
    right: 19px;
    bottom: 0px;
    height: 55px;
    background: #FFFFFF;
    z-index: 1;
  }
  .mansionBaseDiv{
    .baseRow{

    }
    .baseBigRow{

    }
  }
  .otherDiv{
    margin: 0 2% 20px 2%;
    .rowDiv {
      margin: 30px 7% 0 7%
    }
  }


  .amap-page-container {
    position: relative;
    margin: -30px -20px;
  }

  .sum_div{
    display: flex;
  }


  .fileDiv{
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 6px;
    .iconDiv{
      width: 20px
    }
    .nameDiv{
      width:220px;
      font-size: 12px;
      color: #333333;
      letter-spacing: 0;
      margin-left: 5px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .operationDiv{
      margin-left: 5px;display: flex;flex-direction: row
    }
  }

  .add_building{
    margin-top: 15px;
    margin-left: 7%;
    background: #F4F5F8;
    border: 1px solid rgba(162,162,162,1);
    border-radius: 2px;
    font-size: 12px;
    color: #666666;
    font-weight: 600;
    height: 30px;
    width: 135px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .delete_building{
    background: #F4F5F8;
    border: 1px solid rgba(162,162,162,1);
    border-radius: 2px;
    font-size: 12px;
    color: #666666;
    font-weight: 600;
    height: 30px;
    width: 135px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .other_back{
    margin: 30px 5% 0 5%;
    padding: 2%;
    background: #F4F5F8;
  }

}

.industrial_submit{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  border:2px solid #F4F5F8;
  position: fixed;
  left: 198px;
  right: 19px;
  bottom: 0px;
  height: 55px;
  background: #FFFFFF;
  z-index: 1;
}

.serachinput {
  width: 300px;
  box-sizing: border-box;
  padding: 9px;
  border: 1px solid #dddee1;
  line-height: 20px;
  font-size: 16px;
  height: 38px;
  color: #333;
  position: relative;
  border-radius: 4px;
  -webkit-box-shadow: #666 0px 0px 10px;
  -moz-box-shadow: #666 0px 0px 10px;
  box-shadow: #666 0px 0px 10px;
}
.searchResult{
  width: 0;
  height: 0;
  overflow: hidden;
}

.addressRow /deep/ .ant-input-affix-wrapper .ant-input {
  padding-left: 5px !important;
}
.addressRow /deep/ .ant-input-affix-wrapper .ant-input-suffix{
  right: 0 !important;
}

</style>